import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

const Timeout = () => {
  const navigate = useNavigate();
  return (
    <div className="h-screen nc_page-inner flex align-items-center pt-6 lg:p-0 lg:align-items-stretch">
      <div className="hidden lg:flex justify-content-start align-items-end w-full lg:mt-6 lg:w-6 nc_timeout"></div>
      <div className="flex justify-content-center align-items-center w-12 lg:w-6 lg:justify-content-start">
        <div className="nc_block flex flex-column align-items-center w-9 lg:ml-4">
          <h1 className="text-center">Oh, no!</h1>
          <h1 className="text-center">It looks like this page took to long to load!</h1>
          <div className="flex justify-content-center align-items-center gap-lg">
            <h3 className="text-center">You can go back and try again:</h3>
            <Button onClick={() => navigate(-1)} label="Go back" rounded />
          </div>
          <h3 className="text-center">Or use the help center to reach out to us!</h3>
        </div>
      </div>
    </div>
  );
};

export default Timeout;
